import { combineReducers } from "redux"

import Client from "./client/reducer"
import Data from "./data/reducer"
import Language from "./language/reducer"
import Menu from "./menu/reducer"
import User from "./user/reducer"

const rootReducer = combineReducers({
  Client,
  Data,
  Language,
  Menu,
  User,
})

export default rootReducer
export * from "./client/actions"
export * from "./data/actions"
export * from "./language/actions"
export * from "./menu/actions"
export * from "./user/actions"
